import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { isEqual } from 'lodash'
import './index.scss'

class PercentRing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...this.getRotations(Math.round(props.percent), 75, 100),
    }
  }
  getRotations(percent) {
    return {
      percent: percent,
      quad0: this.getRotation(percent, 75, 100),
      quad1: this.getRotation(percent, 0, 25),
      quad2: this.getRotation(percent, 50, 75),
      quad3: this.getRotation(percent, 25, 50),
    }
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.percent, this.props.percent)) {
      this.setState({
        ...this.getRotations(Math.round(this.props.percent), 75, 100),
      })
    }
  }
  getRotation(percent, from, to) {
    const minDeg = 45
    const maxDeg = 135
    let angle = minDeg
    if (percent >= to) {
      angle = maxDeg
    } else if (percent > from) {
      angle = percent * 3.6 - from * 3.6 + minDeg
    }
    return `rotate(${angle}deg)`
  }
  getPercentage() {
    if (isNaN(this.props.percent)) {
      return <Fragment>&mdash;</Fragment>
    }
    return (
      <Fragment>
        {this.props.percent}
        <span className="percent-symbol">%</span>
      </Fragment>
    )
  }
  render() {
    return (
      <div className="percent-ring">
        <div className="center">
          <span className="aligner"></span>
          <span className="alignee">{this.getPercentage()}</span>
        </div>
        <div
          className="quadrant"
          data-index={0}
        >
          <div className="ring-empty">
            <div
              className="ring-filled"
              style={{ transform: this.state.quad0 }}
            ></div>
          </div>
        </div>
        <div
          className="quadrant"
          data-index={1}
        >
          <div className="ring-empty">
            <div
              className="ring-filled"
              style={{ transform: this.state.quad1 }}
            ></div>
          </div>
        </div>
        <div
          className="quadrant"
          data-index={2}
        >
          <div className="ring-empty">
            <div
              className="ring-filled"
              style={{ transform: this.state.quad2 }}
            ></div>
          </div>
        </div>
        <div
          className="quadrant"
          data-index={3}
        >
          <div className="ring-empty">
            <div
              className="ring-filled"
              style={{ transform: this.state.quad3 }}
            ></div>
          </div>
        </div>
      </div>
    )
  }
}
PercentRing.defaultProps = {
  percent: 0,
}

PercentRing.propTypes = {
  percent: PropTypes.number,
}

export default PercentRing
